import { render, staticRenderFns } from "./top-ex.vue?vue&type=template&id=fc2ac3ac&scoped=true&"
import script from "./top-ex.vue?vue&type=script&lang=js&"
export * from "./top-ex.vue?vue&type=script&lang=js&"
import style0 from "./top-ex.vue?vue&type=style&index=0&id=fc2ac3ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2ac3ac",
  null
  
)

export default component.exports